import { render, staticRenderFns } from "./babyTab.vue?vue&type=template&id=de1173dc&scoped=true&"
import script from "./babyTab.vue?vue&type=script&lang=js&"
export * from "./babyTab.vue?vue&type=script&lang=js&"
import style0 from "./babyTab.vue?vue&type=style&index=0&id=de1173dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1173dc",
  null
  
)

export default component.exports